import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-688f38d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/cambridge.png",
  alt: "Cambridge Dictionary",
  class: "dictionary-logo-extra"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/merriam-webster.png",
  alt: "Merriam Webster Dictionary",
  class: "dictionary-logo-extra"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/oxford.png",
  alt: "Oxford Dictionary",
  class: "dictionary-logo-extra"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!

  return (_openBlock(), _createElementBlock("view", null, [
    _createVNode(_component_ion_card, { class: "margin-top-unset" }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_card_header, { class: "label-block" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_card_title, {
              class: _normalizeClass(_ctx.getLabelClass())
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Definition in the renowned dictionary ")
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_row, { class: "display-flex ion-justify-content-center" }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_col, {
          sizeXs: "4",
          sizeSm: "4",
          sizeMd: "3",
          sizeLg: "3",
          sizeXl: "3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_card, {
              button: true,
              href: `https://dictionary.cambridge.org/dictionary/english/${_ctx.word.toLowerCase()}`,
              target: "_blank",
              class: "transparent"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_content, { class: "display-flex ion-justify-content-center ion-padding" }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["href"])
          ]),
          _: 1
        }),
        _createVNode(_component_ion_col, {
          sizeXs: "4",
          sizeSm: "4",
          sizeMd: "3",
          sizeLg: "3",
          sizeXl: "3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_card, {
              button: true,
              href: `https://www.merriam-webster.com/dictionary/${_ctx.word.toLowerCase()}`,
              target: "_blank",
              class: "transparent"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_content, { class: "display-flex ion-justify-content-center ion-padding" }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["href"])
          ]),
          _: 1
        }),
        _createVNode(_component_ion_col, {
          sizeXs: "4",
          sizeSm: "4",
          sizeMd: "3",
          sizeLg: "3",
          sizeXl: "3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_card, {
              button: true,
              href: `https://www.oxfordlearnersdictionaries.com/definition/english/${_ctx.word
                        .toLowerCase()
                        .replace(' ', '-')}_1?q=${_ctx.word.toLowerCase().replace(' ', '+')}`,
              target: "_blank",
              class: "transparent"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_content, { class: "display-flex ion-justify-content-center ion-padding" }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["href"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}